import { IResponsePagination } from "./pagination.types";

export enum JURISDICTION_TYPE_E {
	STATE = 1,
	JURISDICTION = 2,
	RTOS = 3
}

export interface IJurisdictionDescendantDetails {
	id: number;
	name: string;
	pincode: string | null;
	location_co_ordinates: string | null;
	jurisdiction_type: number;
	parent: number;
	description: string;
	rto_code: string;
}

export interface IGetJurisdictionsResponseData {
	id: number;
	name: string;
	pincode: string | null;
	location_co_ordinates: string | null;
	jurisdiction_type: {
		id: number;
		name: string;
	};
	parent: number;
	rto_code: string | null;
	description: string;
	descendants: IJurisdictionDescendantDetails[];
}

export type IGetJurisdictionsResponse = IResponsePagination<IGetJurisdictionsResponseData>;

export interface IGetJurisdictionsListRequestData {
	page?: number;
	search?: string;
	jurisdiction_type?: JURISDICTION_TYPE_E;
	parent?: number;
	all?: boolean;
}

export interface IGetRTOListResponseData {
	id: number;
	name: string;
	rto_code: string;
	description: string;
	jurisdiction: number;
}

export interface IGetRTOListRequestData {
	jurisdiction?: number;
	search?: string;
}

export interface ICreateJurisdictionRequestData {
	name: string;
	pincode?: string;
	location_co_ordinates?: string;
	jurisdiction_type: number;
	parent: number;
	rto_code?: string;
	description?: string | null;
}

export interface IEditJurisdictionRequestData {
	id: number;
	data: {
		name?: string;
		pincode?: string;
		location_co_ordinates?: string;
		jurisdiction_type?: JURISDICTION_TYPE_E;
		parent?: number;
		rto_code?: string;
		description?: string | null;
	};
}
